__turbopack_context__.v({
  "badge": "WelloOnlySection-module-scss-module__ogBXTW__badge",
  "badgePulse": "WelloOnlySection-module-scss-module__ogBXTW__badgePulse",
  "glow": "WelloOnlySection-module-scss-module__ogBXTW__glow",
  "progressCard": "WelloOnlySection-module-scss-module__ogBXTW__progressCard",
  "progressGlow": "WelloOnlySection-module-scss-module__ogBXTW__progressGlow",
  "shimmer": "WelloOnlySection-module-scss-module__ogBXTW__shimmer",
  "timerPulse": "WelloOnlySection-module-scss-module__ogBXTW__timerPulse",
  "urgent": "WelloOnlySection-module-scss-module__ogBXTW__urgent",
  "wiggle": "WelloOnlySection-module-scss-module__ogBXTW__wiggle",
});
